import React from 'react';
import { Contact, Footer } from '../components'
import 'react-toastify/dist/ReactToastify.css';
import Gallery from '../components/Gallery';
import Meta from '../components/common/Meta';



export const GalleryPage = () => {
  
  return (
    <div className='py-10'>
    <Meta
    title="Gallery | Architectural & Construction Designs Rwanda"
    description="Visual gallery of architectural designs, interiors, landscaping, and construction projects completed by Edges Design Group."
    keywords="
      Green & Sustainable Architecture | Rwanda & Africa,
      Architectural design Rwanda,
      Modern house design Rwanda,
      Residential building design,
      Commercial architecture services,
      Interior design Rwanda,
      Interior finishing works Kigali,
      Modern interiors,
      Residential interior solutions,
      Landscaping design Rwanda,
      Garden design Kigali,
      Exterior landscaping services,
      Ibishushanyo mbonera,
      Inzu,
      Green building design Rwanda,
      Sustainable architecture Africa,
      Sustainable architecture Kigali,
      Energy-efficient building design,
      Environmental design consulting,
      Architecture durable Rwanda,
      Conception de bâtiments écologiques,
      Inzu zibungabunga ibidukikije,
      Kubaka hadatakaye ingufu"
      />

      <Gallery/>
      <Contact />
      <div className=' w-full h-1 bg-gray-400'></div>
      <Footer />
    </div>
  )
}

export default GalleryPage
